import { ActionPayload, ID } from "../../types";
import * as types from "../constants/ActionTypes";

export interface AddPackagedPayload {
  id: ID;
  fromId: ID;
}
export const addPackaged = (
  id: ID,
  fromId: ID
): ActionPayload<AddPackagedPayload> => {
  return {
    type: types.ADD_PACKAGED,
    payload: {
      id,
      fromId,
    },
  };
};

export interface RemovePackagedPayload {
  id: ID;
}

export const removePackaged = (
  id: ID
): ActionPayload<RemovePackagedPayload> => {
  return {
    type: types.REMOVE_PACKAGED,
    payload: {
      id,
    },
  };
};
